import React, {useState} from 'react';
import useBatteryStatus from '@di-shared/features/diag/battery/useBatteryStatus';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface DrivingDurationDifferenceProps {
  vin: string;
}

function DrivingDurationDifference({vin}: DrivingDurationDifferenceProps) {
  const {t} = useInferableTranslation();
  const {drivingTimeHour, drivingTimeMin, drivingTimeAverageHour, drivingTimeAverageMin, drivingTimePercentage} = useBatteryStatus(vin);
  const [isOpenDrivingDuration, setIsOpenDrivingDuration] = useState(false);
  const DRIVING_TIME_GRAPH_MAX_HEIGHT = 60;
  const drivingTimeGraphHeight =
    drivingTimePercentage > 100 ? DRIVING_TIME_GRAPH_MAX_HEIGHT : DRIVING_TIME_GRAPH_MAX_HEIGHT * (drivingTimePercentage / 100);
  const drivingTimeAverageGraphHeight =
    drivingTimePercentage <= 100 ? DRIVING_TIME_GRAPH_MAX_HEIGHT : DRIVING_TIME_GRAPH_MAX_HEIGHT * (100 / drivingTimePercentage);
  return (
    <div className="section_container">
      <div className="section_container_header">
        <h3 className="title_xxsmall">{t('T30101')}</h3>
      </div>
      <div className="driving_amount">
        <strong className="driving_amount_average">
          {t('T30102')}{' '}
          <span className="text_emphasis">
            {drivingTimeHour ? t('T30103_$hour', {hour: drivingTimeHour}) : ''} {t('T30104_$minute', {minute: drivingTimeMin})}
          </span>
        </strong>
        <span className="driving_amount_compare">{t('T30105_$ratio', {ratio: drivingTimePercentage})}</span>
        {isOpenDrivingDuration && (
          <div
            className="driving_amount_detail"
            id="drivingAmountDetail"
            style={{display: 'block'}}
          >
            <div className="driving_amount_graph_area">
              <div className="bar_graph type_average">
                <div className="bar_graph_item average_item">
                  <span className="speech_bubble">
                    {drivingTimeAverageHour ? t('T30103_$hour_#short', {hour: drivingTimeAverageHour}) : ''}{' '}
                    {t('T30104_$minute_#short', {minute: drivingTimeAverageMin})}
                  </span>
                  <span
                    className="graph_bar"
                    style={{height: drivingTimeAverageGraphHeight}}
                  ></span>
                  <span className="graph_title">{t('T30146')}</span>
                </div>
                <div className="bar_graph_item my_item is-active">
                  <span className="speech_bubble">
                    {drivingTimeHour ? t('T30103_$hour_#short', {hour: drivingTimeHour}) : ''}{' '}
                    {t('T30104_$minute_#short', {minute: drivingTimeMin})}
                  </span>
                  <span
                    className="graph_bar"
                    style={{height: drivingTimeGraphHeight}}
                  ></span>
                  <span className="graph_title">{t('T30149')}</span>
                </div>
              </div>
            </div>
            <ul className="section_bullet_list body_small_r">
              <li className="section_bullet_item">{t('T30106')}</li>
              <li className="section_bullet_item">{t('T30107')}</li>
            </ul>
          </div>
        )}
      </div>
      <div className="divider"></div>
      <button
        type="button"
        className="btn_unfold"
        aria-expanded={isOpenDrivingDuration}
        aria-controls="drivingAmountDetail"
        onClick={() => setIsOpenDrivingDuration((v) => !v)}
      >
        {t('T30108')} <span className="ic ic_arrow_down_14px"></span>
      </button>
    </div>
  );
}

export default DrivingDurationDifference;
